import { HubRoutingWardViewModel } from "./index";

export class GetDatasFromHubViewModel {
    selectedWardIds: number[];
    wards: HubRoutingWardViewModel[];
}